import {
  createSlice,
  createAsyncThunk,
  createSelector } from
'@reduxjs/toolkit';
import { ApolloClient, gql, NormalizedCacheObject } from '@apollo/client';
import { RootState } from '@src/redux/store';
import * as TYPES from '@src/redux/types';

const GRAPHQL = gql`
  mutation createSystemUiModuleComponent(
    $data: createSystemUiModuleComponentInput!
  ) {
    createSystemUiModuleComponent(data: $data) {
      id
      status
      error {
        message
        statusCode
      }
    }
  }
`;

const initialState: TYPES.MutationResponseState = {
  result: null,
  error: null,
  loading: false
};

export const createSystemUiModuleComponentRequest = createAsyncThunk<
  TYPES.MutationResponse,
  {data: TYPES.CreateSystemUiModuleComponentInput;},
  {extra: ApolloClient<NormalizedCacheObject>;}>(

  'system_ui_module_component/create_system_ui_module_component',
  async (
  params: {data: TYPES.CreateSystemUiModuleComponentInput;},
  { extra: client }) =>
  {
    try {
      const response = await client.mutate({
        mutation: GRAPHQL,
        variables: params
      });
      return response.data.createSystemUiModuleComponent;
    } catch (error) {
      const err = error as {message?: String;statusCode?: String;};
      return Promise.reject({
        message: err.message || 'An error occurred',
        statusCode: err.statusCode || '500'
      });
    }
  }
);

const createSystemUiModuleComponentSlice = createSlice({
  name: 'create_system_ui_module_component',
  initialState: initialState,
  reducers: {
    createSystemUiModuleComponentClear: (state) => {
      state.result = null;
      state.error = null;
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder.
    addCase(createSystemUiModuleComponentRequest.pending, (state) => {
      state.result = null;
      state.error = null;
      state.loading = true;
    }).
    addCase(
      createSystemUiModuleComponentRequest.fulfilled,
      (state, action) => {
        state.result = action.payload;
        state.loading = false;
      }
    ).
    addCase(
      createSystemUiModuleComponentRequest.rejected,
      (state, action) => {
        state.error = action.payload as Error || {
          message: 'Failed to fetch',
          statusCode: '500'
        };
        state.loading = false;
      }
    );
  }
});

export const { createSystemUiModuleComponentClear } =
createSystemUiModuleComponentSlice.actions;

export const createSystemUiModuleComponent = createSelector(
  (state: RootState) =>
  state.systemUiModuleComponent.createSystemUiModuleComponent.result,
  (state: RootState) =>
  state.systemUiModuleComponent.createSystemUiModuleComponent.error,
  (state: RootState) =>
  state.systemUiModuleComponent.createSystemUiModuleComponent.loading,
  (result, error, loading) => ({
    result,
    error,
    loading
  })
);

export default createSystemUiModuleComponentSlice.reducer;